import { login } from '../auth/asyncThunks';
import { deleteLeadClient, setClientWeddingDate } from '../wedding/asyncThunks';
import {
  postVendorInfo,
  fetchAllVendorCategories,
  fetchVendorInfo,
  getClientById,
  getClientsForVendor,
  setNoteForClient,
  changeStatusForClient,
  getVendorWorkingHours,
  setWorkingHoursForVendor,
  getAllClients,
  editVendorInfo,
  createClientByVendor,
  createHashtagsForClient,
  subscribeAndAddPaymentMethod,
  getPaymentIntentsForVendor,
  addPaymentMethod,
  cancelSubscription,
  subscribeWithCoupon,
} from './asyncThunks';

export const postVendorInfoBuilder = builder => {
  builder.addCase(postVendorInfo.pending, state => {
    state.createVendorPending = true;
  });
  builder.addCase(postVendorInfo.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.createVendorPending = false;
    state.userInfo.id = data.id;
    state.userInfo.name = data.name;
    state.userInfo.phoneNumber = data.phoneNumber;
    state.userInfo.email = data.email;
    state.userInfo.address = data.address;
    state.userInfo.showAddress = data.showAddress;
    state.userInfo.instagram = data.instagram === null ? '' : data.instagram;
    state.userInfo.facebook = data.facebook === null ? '' : data.facebook;
    state.userInfo.tiktok = data.tiktok === null ? '' : data.tiktok;
    state.userInfo.twitter = data.twitter === null ? '' : data.twitter;
    state.userInfo.bannerPhoto = data.bannerPhoto;
    state.userInfo.photos = data.photos;
    state.userInfo.links = data.links;
    state.userInfo.rating = data.rating;
    state.userInfo.reviews = data.reviews;
    state.userInfo.googlePlaceLat = data.googlePlaceLat;
    state.userInfo.googlePlaceLong = data.googlePlaceLong;
    state.userInfo.googlePlaceId = data.googlePlaceId;
    state.userInfo.hasSubscriptionTo = data.hasSubscriptionTo;
    state.userInfo.paymentMethod = data.paymentMethod;
    state.userInfo.subscription = data.subscription;
    state.userInfo.websiteLink = data.websiteLink;
    state.userInfo.onboardingFinishedAt = data.onboardingFinishedAt;
    state.userInfo.hasCoupon = data.hasCoupon;
    state.userInfo.emailToShow = data.emailToShow;

    // if (data.hasSubscribed) {
    //   state.openSubscriptionModal = false;
    // } else {
    state.openSubscriptionModal = true;
    // }
  });
  builder.addCase(postVendorInfo.rejected, state => {
    state.createVendorPending = false;
  });
};

export const loginVendorBuilder = builder => {
  builder.addCase(login.fulfilled, (state, action) => {
    const { vendor } = action.payload;
    state.userInfo.id = vendor.id;
    state.userInfo.name = vendor.name;
    state.userInfo.phoneNumber = vendor.phoneNumber;
    state.userInfo.email = vendor.email;
    state.userInfo.address = vendor.address;
    state.userInfo.showAddress = vendor.showAddress;
    state.userInfo.instagram = vendor.instagram === null ? '' : vendor.instagram;
    state.userInfo.facebook = vendor.facebook === null ? '' : vendor.facebook;
    state.userInfo.tiktok = vendor.tiktok === null ? '' : vendor.tiktok;
    state.userInfo.twitter = vendor.twitter === null ? '' : vendor.twitter;
    state.userInfo.bannerPhoto = vendor.bannerPhoto;
    state.userInfo.photos = vendor.photos;
    state.userInfo.links = vendor.links;
    state.userInfo.rating = vendor.rating;
    state.userInfo.reviews = vendor.reviews;
    state.userInfo.googlePlaceLat = vendor.googlePlaceLat;
    state.userInfo.googlePlaceLong = vendor.googlePlaceLong;
    state.userInfo.googlePlaceId = vendor.googlePlaceId;
    state.userInfo.hasSubscriptionTo = vendor.hasSubscriptionTo;
    state.userInfo.paymentMethod = vendor.paymentMethod;
    state.userInfo.subscription = vendor.subscription;
    state.userInfo.websiteLink = vendor.websiteLink;
    state.userInfo.onboardingFinishedAt = vendor.onboardingFinishedAt;
    state.userInfo.hasCoupon = vendor.hasCoupon;
    state.userInfo.emailToShow = vendor.emailToShow;

    if (vendor.hasSubscribed) {
      state.openSubscriptionModal = false;
    } else {
      state.openSubscriptionModal = true;
      state.closeSubscriptionModalDisabled = true;
    }
  });
};

export const editVendorInfoBuilder = builder => {
  builder.addCase(editVendorInfo.pending, state => {
    state.editVendorPending = true;
  });
  builder.addCase(editVendorInfo.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.editVendorPending = false;
    state.userInfo.id = data.id;
    state.userInfo.name = data.name;
    state.userInfo.phoneNumber = data.phoneNumber;
    state.userInfo.email = data.email;
    state.userInfo.address = data.address;
    state.userInfo.showAddress = data.showAddress;
    state.userInfo.instagram = data.instagram === null ? '' : data.instagram;
    state.userInfo.facebook = data.facebook === null ? '' : data.facebook;
    state.userInfo.tiktok = data.tiktok === null ? '' : data.tiktok;
    state.userInfo.twitter = data.twitter === null ? '' : data.twitter;
    state.userInfo.bannerPhoto = data.bannerPhoto;
    state.userInfo.photos = data.photos;
    state.userInfo.links = data.links;

    state.userInfo.rating = data.rating;
    state.userInfo.reviews = data.reviews;
    state.userInfo.googlePlaceLat = data.googlePlaceLat;
    state.userInfo.googlePlaceLong = data.googlePlaceLong;
    state.userInfo.googlePlaceId = data.googlePlaceId;
    state.userInfo.websiteLink = data.websiteLink;
    state.userInfo.emailToShow = data.emailToShow;
  });
  builder.addCase(editVendorInfo.rejected, state => {
    state.editVendorPending = false;
  });
};

export const fetchAllVendorCategoriesBuilder = builder => {
  builder.addCase(fetchAllVendorCategories.pending, state => {
    state.fetchAllVendorCategoryPending = true;
  });
  builder.addCase(fetchAllVendorCategories.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.allVendorCategories.data = data;
    state.fetchAllVendorCategoryPending = false;
  });
  builder.addCase(fetchAllVendorCategories.rejected, state => {
    state.fetchAllVendorCategoryPending = false;
  });
};

export const getClientsForVendorBuilder = builder => {
  builder.addCase(getClientsForVendor.pending, state => {
    state.getClientsForVendorPending = true;
  });
  builder.addCase(getClientsForVendor.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, page, perPage } = payload;

    state.allVendorClients.data = data;

    state.allVendorClients.page = page;
    state.allVendorClients.perPage = perPage;
    state.allVendorClients.maxReached = maxReached;
    state.allVendorClients.total = total;
    state.getClientsForVendorPending = false;
  });
  builder.addCase(getClientsForVendor.rejected, state => {
    state.getClientsForVendorPending = false;
  });
};

export const fetchVendorInfoBuilder = builder => {
  builder.addCase(fetchVendorInfo.pending, state => {
    state.gettingVendorInfo = true;
  });
  builder.addCase(fetchVendorInfo.fulfilled, (state, action) => {
    state.gettingVendorInfo = false;
    const {
      id,
      name,
      email,
      address,
      instagram,
      tiktok,
      facebook,
      twitter,
      bannerPhoto,
      photos,
      links,
      phoneNumber,
      showAddress,
      rating,
      reviews,
      googlePlaceLat,
      googlePlaceLong,
      googlePlaceId,
      hasSubscribed,
      hasSubscriptionTo,
      paymentMethod,
      subscription,
      websiteLink,
      onboardingFinishedAt,
      vendorCategory,
      hasCoupon,
      emailToShow,
    } = action.payload;
    state.userInfo.id = id;
    state.userInfo.name = name;
    state.userInfo.phoneNumber = phoneNumber;
    state.userInfo.email = email;
    state.userInfo.address = address;
    state.userInfo.showAddress = showAddress;
    state.userInfo.instagram = instagram === null ? '' : instagram;
    state.userInfo.facebook = facebook === null ? '' : facebook;
    state.userInfo.tiktok = tiktok === null ? '' : tiktok;
    state.userInfo.twitter = twitter === null ? '' : twitter;
    state.userInfo.bannerPhoto = bannerPhoto;
    state.userInfo.photos = photos;
    state.userInfo.links = links;
    state.userInfo.rating = rating;
    state.userInfo.reviews = reviews;
    state.userInfo.googlePlaceLat = googlePlaceLat;
    state.userInfo.googlePlaceLong = googlePlaceLong;
    state.userInfo.googlePlaceId = googlePlaceId;
    state.userInfo.hasSubscriptionTo = hasSubscriptionTo;
    state.userInfo.paymentMethod = paymentMethod;
    state.userInfo.subscription = subscription;
    state.userInfo.websiteLink = websiteLink;
    state.userInfo.onboardingFinishedAt = onboardingFinishedAt;
    state.userInfo.vendorCategory = vendorCategory;
    state.userInfo.hasCoupon = hasCoupon;
    state.userInfo.emailToShow = emailToShow;

    if (hasSubscribed || !name || !onboardingFinishedAt) {
      state.openSubscriptionModal = false;
    } else {
      state.openSubscriptionModal = true;
      state.closeSubscriptionModalDisabled = true;
    }
  });
  builder.addCase(fetchVendorInfo.rejected, state => {
    state.gettingVendorInfo = false;
  });
};

export const getClientByIdBuilder = builder => {
  builder
    .addCase(getClientById.pending, state => {
      state.selectedClient.getClientByIdPending = true;
    })
    .addCase(getClientById.fulfilled, (state, action) => {
      state.selectedClient.data = action.payload.data;
      state.selectedClient.getClientByIdPending = false;
    })
    .addCase(getClientById.rejected, (state, action) => {
      state.selectedClient.getClientByIdPending = false;
    });
};

export const setClientNoteBuilder = builder => {
  builder.addCase(setNoteForClient.pending, state => {
    state.setClientNotePending = true;
  });
  builder.addCase(setNoteForClient.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.selectedClient.data.note = data.note;

    state.setClientNotePending = false;
  });
  builder.addCase(setNoteForClient.rejected, (state, action) => {
    state.setClientNotePending = false;
  });
};

export const changeClientStatusBuilder = builder => {
  builder.addCase(changeStatusForClient.pending, state => {
    state.changeClientStatusPending = true;
  });
  builder.addCase(changeStatusForClient.fulfilled, (state, action) => {
    const { data, weddingVendorId } = action.payload;

    if (state.selectedClient.data.weddingVendorId === weddingVendorId) {
      state.selectedClient.data.clientStatus = data.status;
    }
    state.changeClientStatusPending = false;
  });
  builder.addCase(changeStatusForClient.rejected, (state, action) => {
    state.changeClientStatusPending = false;
  });
};

export const getVendorWorkingHoursBuilder = builder => {
  builder.addCase(getVendorWorkingHours.pending, state => {
    state.getWorkingHoursPending = true;
  });
  builder.addCase(getVendorWorkingHours.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.getWorkingHoursPending = false;
    state.userInfo.workingHours = data.workingHours;
  });
  builder.addCase(getVendorWorkingHours.rejected, state => {
    state.getWorkingHoursPending = false;
  });
};

export const setVendorWorkingHoursBuilder = builder => {
  builder.addCase(setWorkingHoursForVendor.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.userInfo.workingHours = data.workingHours;
  });
};

export const getAllClientsBuilder = builder => {
  builder.addCase(getAllClients.pending, state => {
    state.getAllClientsPending = true;
  });
  builder.addCase(getAllClients.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.allClients.data = data;
    state.getAllClientsPending = false;
  });
  builder.addCase(getAllClients.rejected, state => {
    state.getAllClientsPending = false;
  });
};

export const createClientByVendorBuilder = builder => {
  builder.addCase(createClientByVendor.pending, state => {
    state.createClientByVendorPending = true;
  });
  builder.addCase(createClientByVendor.fulfilled, (state, { payload }) => {
    const { data } = payload;

    if (data) {
      state.allVendorClients.data = [...state.allVendorClients.data, data];
    }
    state.createClientByVendorPending = false;
  });
  builder.addCase(createClientByVendor.rejected, state => {
    state.createClientByVendorPending = false;
  });
};

export const createClientHashtagsBuilder = builder => {
  builder.addCase(createHashtagsForClient.pending, state => {
    state.createClientHashtagsPending = true;
  });
  builder.addCase(createHashtagsForClient.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.selectedClient.data.hashtags = data;

    state.createClientHashtagsPending = false;
  });
  builder.addCase(createHashtagsForClient.rejected, (state, action) => {
    state.createClientHashtagsPending = false;
  });
};

export const subscribeAndAddPaymentMethodBuilder = builder => {
  builder.addCase(subscribeAndAddPaymentMethod.pending, state => {
    state.subscribeAndAddPaymentMethodPending = true;
  });
  builder.addCase(subscribeAndAddPaymentMethod.fulfilled, (state, action) => {
    const { subscription, paymentMethod, hasSubscriptionTo } = action.payload.data;

    state.openSubscriptionModal = false;
    state.closeSubscriptionModalDisabled = false;

    state.userInfo.hasSubscriptionTo = hasSubscriptionTo;
    state.userInfo.paymentMethod = paymentMethod;
    state.userInfo.subscription = subscription;

    state.subscribeAndAddPaymentMethodPending = false;
  });
  builder.addCase(subscribeAndAddPaymentMethod.rejected, (state, action) => {
    state.subscribeAndAddPaymentMethodPending = false;
  });
};

export const addPaymentMethodBuilder = builder => {
  builder.addCase(addPaymentMethod.pending, state => {
    state.addPaymentMethodPending = true;
  });
  builder.addCase(addPaymentMethod.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.userInfo.paymentMethod = data;

    state.addPaymentMethodPending = false;
  });
  builder.addCase(addPaymentMethod.rejected, (state, action) => {
    state.addPaymentMethodPending = false;
  });
};

export const getPaymentsIntentsForVendorBuilder = builder => {
  builder.addCase(getPaymentIntentsForVendor.pending, state => {
    state.getPaymentIntentsForVendorPending = true;
  });
  builder.addCase(getPaymentIntentsForVendor.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, page, perPage } = payload;
    state.paymentIntents.data = data;
    state.paymentIntents.page = page;
    state.paymentIntents.perPage = perPage;
    state.paymentIntents.maxReached = maxReached;
    state.paymentIntents.total = total;
    state.getPaymentIntentsForVendorPending = false;
  });
  builder.addCase(getPaymentIntentsForVendor.rejected, state => {
    state.getPaymentIntentsForVendorPending = false;
  });
};

export const cancelSubscriptionBuilder = builder => {
  builder.addCase(cancelSubscription.pending, state => {
    state.cancelSubscriptionPending = true;
  });
  builder.addCase(cancelSubscription.fulfilled, (state, action) => {
    state.cancelSubscriptionPending = false;
    state.userInfo.subscription = { ...state.userInfo.subscription, canceledAt: new Date().toLocaleDateString() };
  });
  builder.addCase(cancelSubscription.rejected, (state, action) => {
    state.cancelSubscriptionPending = false;
  });
};

export const setClientWeddingDateBuilder = builder => {
  builder.addCase(setClientWeddingDate.fulfilled, (state, { payload }) => {
    const { id, dateOfWedding } = payload;
    if (state.selectedClient.data.id === id) {
      state.selectedClient.data = {
        ...state.selectedClient.data,
        weddingDate: new Date(+dateOfWedding).toISOString(),
      };
    }

    state.allVendorClients.data = state.allVendorClients.data.map(client => {
      if (client.id === id) {
        client.weddingDate = new Date(+dateOfWedding).toISOString();
      }
      return client;
    });
  });
};

export const subscribeWithCouponBuilder = builder => {
  builder.addCase(subscribeWithCoupon.pending, state => {
    state.subscribeWithCouponPending = true;
  });
  builder.addCase(subscribeWithCoupon.fulfilled, (state, action) => {
    const { hasSubscriptionTo } = action.payload.data;

    state.userInfo.hasSubscriptionTo = hasSubscriptionTo;
    state.userInfo.hasCoupon = true;

    state.subscribeWithCouponPending = false;
  });
  builder.addCase(subscribeWithCoupon.rejected, (state, action) => {
    state.subscribeWithCouponPending = false;
  });
};

export const deleteLeadClientBuilder = builder => {
  builder.addCase(deleteLeadClient.pending, state => {
    state.deleteLeadClientPending = true;
  });
  builder.addCase(deleteLeadClient.fulfilled, (state, { payload }) => {
    const { id } = payload;

    state.allVendorClients.data = state.allVendorClients.data.filter(client => client.id !== id);

    state.deleteLeadClientPending = false;
  });
  builder.addCase(deleteLeadClient.rejected, state => {
    state.deleteLeadClientPending = false;
  });
};
